import { render } from "./ChooseDashboardDeviceColumn.vue?vue&type=template&id=2cd0f63e"
import script from "./ChooseDashboardDeviceColumn.vue?vue&type=script&lang=js"
export * from "./ChooseDashboardDeviceColumn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__